import React, { useEffect, useState } from "react";
import "./requestShift.scss";

import HeaderBar from "../../components/headerBar/HeaderBar";
import VoidSpace from "../../components/voidSpace/VoidSpace";
import SearchInput from "../../components/searchInput/SearchInput";
import RequestShiftBox from "../requestShift/components/requestShiftBox/RequestShiftBox";

import { t } from "i18next";
import { setGlobalState } from "../../utils/state";
import { gestioneSnackbar } from "../../utils/common";
import { useParams } from "react-router-dom";
import {
  confirmSubscriptionShiftWS,
  getWaitingShiftWS,
} from "./api/requestShiftApi";
import { isEmpty } from "../../utils/validation";
import { Col, Row } from "react-bootstrap";

const RequestShift = () => {
  const { id_association } = useParams();

  const [search, setSearch] = useState("");
  const [waitingShifts, setWaitingShifts] = useState([]);
  const [filteredWaitingShifts, setFilteredWaitingShifts] = useState([]);

  useEffect(() => {
    setGlobalState("selectedIdBottomBar", 2);

    getWaitingShiftWS({ id_association })
      .then((res) => {
        setWaitingShifts(res);
        setFilteredWaitingShifts(res);
      })
      .catch((err) => console.log(err));
  }, []);

  const searchFunction = () => {
    if (!isEmpty(search)) {
      setFilteredWaitingShifts(
        waitingShifts.filter((shift) => {
          const name = shift.name?.toLowerCase() || "";
          const surname = shift.surname?.toLowerCase() || "";
          const nameEvent = shift.name_event?.toLowerCase() || "";

          return (
            name.includes(search.toLowerCase()) ||
            surname.includes(search.toLowerCase()) ||
            nameEvent.includes(search.toLowerCase())
          );
        })
      );
    } else {
      setFilteredWaitingShifts(waitingShifts);
    }
  };

  const handleClick = (id, confirmed) => {
    console.log(id_association);
    confirmSubscriptionShiftWS({ id_user_shift: id, confirmed })
      .then((res) => {
        gestioneSnackbar(true, res.message, "success");
        getWaitingShiftWS({ id_association })
          .then((response) => {
            setWaitingShifts(response);
            setFilteredWaitingShifts(response);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => gestioneSnackbar(true, err.message, "error"));
  };

  return (
    <>
      <HeaderBar
        title={t("request_shift.title")}
        back={true}
        path={"/dashboard/" + id_association}
      />
      <div className="waiting-request-container responsive-container">
        <SearchInput
          search={search}
          setSearch={setSearch}
          searchFunction={searchFunction}
        />
        {!isEmpty(filteredWaitingShifts) ? (
          <div>
            <Row sm={1} md={1} lg={2} xl={2} className="g-2">
              {filteredWaitingShifts.map((item, index) => (
                <Col
                  sm={12}
                  md={12}
                  lg={6}
                  xl={6}
                  key={index}
                  className="d-flex justify-content-center"
                >
                  <RequestShiftBox
                    id={item.id}
                    title={item.title}
                    name={item.name}
                    surname={item.surname}
                    image={item.image}
                    name_event={item.name_event}
                    start_datetime={item.start_datetime}
                    end_datetime={item.end_datetime}
                    linkDetailsShift={`/event/${item.id_event}/${item.id_shift}?admin=${id_association}`}
                    callback={handleClick}
                    role={item.role}
                  />
                </Col>
              ))}
            </Row>
          </div>
        ) : null}
      </div>
      <VoidSpace />
    </>
  );
};

export default RequestShift;
